const createField = (config) => config;

const DEVELOPMENT_LOAN_TYPES = [
  "residential development finance",
  "commercial development finance",
];

const isDevelopmentLoan = (data) =>
  DEVELOPMENT_LOAN_TYPES.includes(
    `${data.ProductType || ""}`.trim().toLowerCase()
  );

const isFixedRate = (data) =>
  `${data?.RateType || ""}`.trim().toLowerCase() === "fixed";

const isHybridMethod = (data) =>
  `${data?.InterestPaymentMethod || ""}`.trim().toLowerCase() === "hybrid";

const MAIN_TABS = [
  "Loan Details",
  "Loan Terms",
  "Fees",
  "Cost Details",
  "Insurance Details",
  "Risk Rating",
  "Notes",
];

const INSURANCE_POLICY_TYPE_OPTIONS = [
  { label: "Contract Works", value: "contract works" },
  { label: "Public Liability", value: "public liability" },
  { label: "Buildings", value: "buildings" },
  { label: "PI", value: "PI" },
];

const BOOLEAN_OPTIONS = [
  { label: "Yes", value: "true" },
  { label: "No", value: "false" },
];

const YES_NO_OPTIONS = [
  { label: "Yes", value: "Yes" },
  { label: "No", value: "No" },
];

export const FIELD_CATALOG = [
  // createField({
  //   backendKey: "ApplicationId",
  //   label: "id",
  //   type: "string",
  //   showOnForm: false,
  // }),
  // createField({
  //   backendKey: "LoanId",
  //   label: "Loan Id",
  //   type: "string",
  //   showOnForm: false,
  // }),
  createField({
    backendKey: "LoanName",
    label: "Project Name",
    type: "string",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "BorrowerName",
    label: "Borrower Name",
    type: "lookup",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "KeyPrincipalName",
    label: "Key Principal Name",
    type: "string",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "ExposureGroupName",
    label: "Exposure Group",
    type: "exposure-group-search",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "City",
    label: "City",
    type: "string",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "Postcode",
    label: "Postcode",
    type: "search-string",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "Region",
    label: "Region",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "ProductType",
    label: "Product Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "LoanType",
    label: "Loan Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "LoanPurpose",
    label: "Loan Purpose",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "DevelopmentType",
    label: "Development Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "UnitType",
    label: "Unit Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "LoanSource",
    label: "Loan Source",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "LeadSourceDetail",
    label: "Lead Source Detail",
    type: "string",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "AccountReferenceNumber",
    label: "Account Reference Number",
    type: "string",
    requiredFlag: "N",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "MigrationIndicator",
    label: "Migration Indicator",
    type: "optionset",
    requiredFlag: "N",
    section: "Loan Details",
    showOnForm: true,
    fixedOptions: YES_NO_OPTIONS,
  }),
  createField({
    backendKey: "SecurityTenureType",
    label: "Security Tenure Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "CustomerType",
    label: "Customer Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "Currency",
    label: "Currency",
    type: "optionset",
    requiredFlag: "Y",
    defaultValue: "GBP",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "BusinessDevelopmentManager",
    label: "Business Development Manager",
    type: "lookup",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "LendingDirector",
    label: "Lending Director",
    type: "lookup",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "RelationshipManager",
    label: "Relationship Manager",
    type: "lookup",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "PortfolioManager",
    label: "Portfolio Manager",
    type: "lookup",
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "PropertyAddress",
    label: "Property Address",
    type: "text",
    multiline: true,
    rows: 3,
    requiredFlag: "Y",
    section: "Loan Details",
    showOnForm: true,
    fullWidth: true,
  }),
  createField({
    backendKey: "DrawdownDistributionType",
    label: "Drawdown Distribution Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Terms",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "AOTLimit",
    label: "AOT Limit",
    type: "float",
    requiredFlag: "Y",
    section: "Loan Terms",
    showOnForm: true,
  }),
  // createField({
  //   backendKey: "BuildTrancheLimit",
  //   label: "Build Tranche Limit",
  //   type: "float",
  //   requiredFlag: "Y",
  //   section: "Loan Terms",
  //   showOnForm: false,
  //   visibleWhen: isDevelopmentLoan,
  // }),
  // createField({
  //   backendKey: "LandDrawdown",
  //   label: "Land Drawdown",
  //   type: "float",
  //   requiredFlag: "Y",
  //   section: "Loan Terms",
  //   showOnForm: false,
  // }),
  // createField({
  //   backendKey: "LoanAdvance",
  //   label: "Loan Advance",
  //   type: "float",
  //   showOnForm: false,
  // }),
  createField({
    backendKey: "LoanTerm",
    label: "Loan Term",
    type: "integer",
    requiredFlag: "Y",
    validationRule: ">= 1.",
    section: "Loan Terms",
    showOnForm: true,
  }),
  createField({
    backendKey: "ProjectStartDate",
    label: "Project Start Date",
    type: "date",
    requiredFlag: "Y",
    section: "Loan Terms",
    showOnForm: true,
    helperText: "DD/MM/YYYY",
  }),
  createField({
    backendKey: "BuildStartDate",
    label: "Build Start Date",
    type: "date",
    requiredFlag: "Y",
    section: "Loan Terms",
    showOnForm: true,
    helperText: "DD/MM/YYYY",
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "PracticalCompletionDate",
    label: "Practical Completion Date",
    type: "date",
    requiredFlag: "Y",
    section: "Loan Terms",
    showOnForm: true,
    helperText: "DD/MM/YYYY",
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "SaleVoidDays",
    label: "Sale Void Days",
    type: "integer",
    requiredFlag: "N",
    defaultValue: 30,
    section: "Loan Terms",
    showOnForm: true,
  }),
  // createField({
  //   backendKey: "SaleProgrameDays",
  //   label: "Sale Programe Days",
  //   type: "integer",
  //   requiredFlag: "N",
  //   section: "Loan Terms",
  //   showOnForm: true,
  // }),
  createField({
    backendKey: "SVR",
    label: "SVR",
    type: "float",
    requiredFlag: "Y",
    section: "Loan Terms",
    showOnForm: true,
  }),
  createField({
    backendKey: "RateType",
    label: "Rate Type",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Terms",
    showOnForm: true,
  }),
  createField({
    backendKey: "FixedRate",
    label: "Fixed Rate",
    type: "float",
    requiredFlag: "Y",
    section: "Loan Terms",
    showOnForm: true,
    visibleWhen: isFixedRate,
  }),
  createField({
    backendKey: "MarginRate",
    label: "Margin Rate",
    type: "float",
    requiredFlag: "Y",
    section: "Loan Terms",
    showOnForm: true,
    visibleWhen: (data) => !isFixedRate(data),
  }),
  createField({
    backendKey: "DayCountBasis",
    label: "Day Count Basis",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Terms",
    showOnForm: true,
  }),
  createField({
    backendKey: "InterestPaymentMethod",
    label: "Interest Payment Method",
    type: "optionset",
    requiredFlag: "Y",
    section: "Loan Terms",
    showOnForm: true,
  }),

  // createField({
  //   backendKey: "MaximumLTGDV(%)",
  //   label: "Maximum LTGDV (%)",
  //   type: "float",
  //   requiredFlag: "N",
  //   showOnForm: true,
  // }),
  createField({
    backendKey: "ArrangementFeeRate",
    label: "Arrangement Fee (%)",
    type: "float",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "arrangementFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "ArrangementFeeAmount",
    label: "Arrangement Fee (Amount)",
    type: "float",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "arrangementFee",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "ArrangementFeePaymentMethod",
    label: "Arrangement Fee Payment Method",
    type: "optionset",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "arrangementFee",
  }),
  createField({
    backendKey: "CommitmentFeeRate",
    label: "Commitment Fee (%)",
    type: "float",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: false,
    feeModeGroup: "commitmentFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "CommitmentFeeAmount",
    label: "Commitment Fee (Amount)",
    type: "float",
    requiredFlag: "N",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "commitmentFee",
    feeModeValue: "amount",
  }),
  // createField({
  //   backendKey: "RedemptionDate",
  //   label: "Redemption Date",
  //   type: "date",
  //   showOnForm: false,
  // }),
  // createField({
  //   backendKey: "ClosedDate",
  //   label: "Closed Date",
  //   type: "date",
  //   showOnForm: false,
  // }),
  createField({
    backendKey: "ExitFeeRate",
    label: "Exit Fee (%)",
    type: "float",
    requiredFlag: "N",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "exitFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "ExitFeeAmount",
    label: "Exit Fee (Amount)",
    type: "float",
    requiredFlag: "N",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "exitFee",
    feeModeValue: "amount",
  }),
  // createField({
  //   backendKey: "ExitFeePaymentMethod",
  //   label: "Exit Fee Payment Method",
  //   type: "optionset",
  //   showOnForm: false,
  // }),
  createField({
    backendKey: "ExitStrategy",
    label: "Exit Strategy",
    type: "optionset",
    requiredFlag: "N",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "exitFee",
  }),
  // createField({
  //   backendKey: "MonitoringFeeRate",
  //   label: "Monitoring Fee Rate",
  //   type: "float",
  //   requiredFlag: "Y",
  //   section: "Fees",
  //   showOnForm: false,
  //   feeModeGroup: "monitoringFee",
  //   feeModeValue: "rate",
  // }),
  // createField({
  //   backendKey: "MonitoringFeeAmount",
  //   label: "Monitoring Fee Amount",
  //   type: "float",
  //   requiredFlag: "Y",
  //   section: "Fees",
  //   showOnForm: false,
  //   feeModeGroup: "monitoringFee",
  //   feeModeValue: "amount",
  // }),
  // createField({
  //   backendKey: "MonitoringFeePaymentMethod",
  //   label: "Monitoring Fee Payment Method",
  //   type: "optionset",
  //   requiredFlag: "Y",
  //   section: "Fees",
  //   showOnForm: false,
  //   feeModeGroup: "monitoringFee",
  // }),
  createField({
    backendKey: "BrokerFeeRate",
    label: "Broker Fee Rate",
    type: "float",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "brokerFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "BrokerFeeAmount",
    label: "Broker Fee Amount",
    type: "float",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "brokerFee",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "BrokerFeePaymentMethod",
    label: "Broker Fee Payment Method",
    type: "optionset",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "brokerFee",
  }),
  createField({
    backendKey: "ValuationFeeRate",
    label: "Valuation Fee Rate",
    type: "float",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: false,
    feeModeGroup: "valuationFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "ValuationFeeAmount",
    label: "Valuation Fee Amount",
    type: "float",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "valuationFee",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "ValuationFeePaymentMethod",
    label: "Valuation Fee Payment Method",
    type: "optionset",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "valuationFee",
  }),
  createField({
    backendKey: "LenderFeeRate",
    label: "Lender Legal Fee Rate",
    type: "float",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: false,
    feeModeGroup: "lenderFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "LenderFeeAmount",
    label: "Lender Legal Fee Amount",
    type: "float",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "lenderFee",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "LenderFeePaymentMethod",
    label: "Lender Legal Fee Payment Method",
    type: "optionset",
    requiredFlag: "Y",
    section: "Fees",
    showOnForm: false,
    feeModeGroup: "lenderFee",
  }),
  // createField({
  //   backendKey: "DefaultDate",
  //   label: "Default Date",
  //   type: "date",
  //   showOnForm: false,
  // }),
  // createField({
  //   backendKey: "DefaultInterestRate",
  //   label: "Default Interest Rate",
  //   type: "float",
  //   showOnForm: false,
  // }),
  // createField({
  //   backendKey: "ExtensionDate",
  //   label: "Extension Date",
  //   type: "date",
  //   showOnForm: false,
  // }),
  createField({
    backendKey: "ExtensionFeeRate",
    label: "Extension Fee Rate",
    type: "float",
    requiredFlag: "N",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "extensionFee",
    feeModeValue: "rate",
  }),
  createField({
    backendKey: "ExtensionFeeAmount",
    label: "Extension Fee Amount",
    type: "float",
    requiredFlag: "N",
    section: "Fees",
    showOnForm: true,
    feeModeGroup: "extensionFee",
    feeModeValue: "amount",
  }),
  // createField({
  //   backendKey: "ExtensionFeePaymentMethod",
  //   label: "Extension Fee Payment Method",
  //   type: "optionset",
  //   showOnForm: false,
  // }),
  createField({
    backendKey: "ExtensionOptions",
    label: "Extension Options",
    type: "text",
    multiline: true,
    rows: 3,
    section: "Notes",
    required: "N",
    showOnForm: true,
    fullWidth: true,
  }),
  createField({
    backendKey: "PolicyType",
    label: "Policy Type",
    type: "optionset",
    requiredFlag: "N",
    section: "Insurance Details",
    showOnForm: true,
    fixedOptions: INSURANCE_POLICY_TYPE_OPTIONS,
  }),
  createField({
    backendKey: "Insurer",
    label: "Insurer",
    type: "string",
    requiredFlag: "N",
    section: "Insurance Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "PolicyNumber",
    label: "Policy Number",
    type: "string",
    requiredFlag: "N",
    section: "Insurance Details",
    showOnForm: true,
  }),
  createField({
    backendKey: "InsuranceStartDate",
    label: "Start Date",
    type: "date",
    requiredFlag: "N",
    section: "Insurance Details",
    showOnForm: true,
    helperText: "DD/MM/YYYY",
  }),
  createField({
    backendKey: "InsuranceEndDate",
    label: "End Date",
    type: "date",
    requiredFlag: "N",
    section: "Insurance Details",
    showOnForm: true,
    helperText: "DD/MM/YYYY",
  }),
  createField({
    backendKey: "SumInsured",
    label: "Sum Insured",
    type: "decimal",
    requiredFlag: "N",
    section: "Insurance Details",
    showOnForm: true
  }),
  createField({
    backendKey: "Excess",
    label: "Excess",
    type: "decimal",
    requiredFlag: "N",
    section: "Insurance Details",
    showOnForm: true
  }),
  createField({
    backendKey: "LenderNoted",
    label: "Lender Noted",
    type: "boolean",
    requiredFlag: "N",
    section: "Insurance Details",
    showOnForm: true,
    fixedOptions: BOOLEAN_OPTIONS,
  }),
  createField({
    backendKey: "RepaymentProfile",
    label: "Repayment Profile",
    type: "optionset",
    requiredFlag: "N",
    section: "Loan Terms",
    showOnForm: true,
  }),
  createField({
    backendKey: "BrokerNotes",
    label: "Broker / Applicant Notes",
    type: "text",
    multiline: true,
    rows: 4,
    section: "Notes",
    required: "N",
    showOnForm: true,
    fullWidth: true,
  }),
  createField({
    backendKey: "PriorityStatus",
    label: "Priority Status",
    type: "optionset",
    requiredFlag: "N",
    section: "Loan Terms",
    showOnForm: true,
  }),
  createField({
    backendKey: "MarketValuation",
    label: "Market Valuation",
    type: "float",
    requiredFlag: "N",
    section: "Loan Terms",
    showOnForm: true,
  }),
  createField({
    backendKey: "ServicedAmount",
    label: "Serviced Amount",
    type: "float",
    requiredFlag: "N",
    section: "Loan Terms",
    showOnForm: true,
    visibleWhen: isHybridMethod,
    feeModeGroup: "servicedHybrid",
    feeModeValue: "amount",
  }),
  createField({
    backendKey: "ServicedRate",
    label: "Serviced Rate",
    type: "float",
    requiredFlag: "N",
    section: "Loan Terms",
    showOnForm: true,
    visibleWhen: isHybridMethod,
    feeModeGroup: "servicedHybrid",
    feeModeValue: "rate",
  }),
  // createField({
  //   backendKey: "LoanStatus",
  //   label: "Loan Status",
  //   type: "string",
  //   showOnForm: false,
  // }),
  // createField({
  //   backendKey: "IsLoanCompleted",
  //   label: "Created By",
  //   type: "string",
  //   showOnForm: false,
  // }),
  createField({
    backendKey: "CreatedBy",
    label: "Created By",
    type: "string",
    showOnForm: false,
  }),
  createField({
    backendKey: "PurchasePrice",
    label: "Purchase Price",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Land",
    showOnForm: true,
  }),
  createField({
    backendKey: "AmountSpentSincePurchase",
    label: "Funds Spent On Site Since Purchase",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Land",
    showOnForm: true,
  }),
  createField({
    backendKey: "StampDutyPercent",
    label: "Stamp Duty",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Land",
    showOnForm: true,
  }),
  // createField({
  //   backendKey: "StampDutyAmount",
  //   label: "Stamp Duty Amount",
  //   type: "float",
  //   showOnForm: false,
  // }),
  createField({
    backendKey: "DemoAndInfrastructure",
    label: "Demo & Infrastructure",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Construction",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "EquitySpentByBorrowerOnConstruction",
    label: "Borrower's Equity To Be Spent On Build",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Construction",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "MainBuild",
    label: "Main Build",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Unit Construction",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  // createField({
  //   backendKey: "EquitySpentByBorrowerOnUnitConstruction",
  //   label: "Borrower's Equity To Be Spent On Build",
  //   type: "float",
  //   requiredFlag: "Y",
  //   section: "Cost Details",
  //   subSection: "Unit Construction",
  //   showOnForm: true,
  //   visibleWhen: isDevelopmentLoan,
  // }),
  createField({
    backendKey: "ContingencyPercent",
    label: "Contingency (% of Main Build)",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Unit Construction",
    showOnForm: true,
  }),

  createField({
    backendKey: "ProfessionalFees",
    label: "Professional Fees",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Professional Fees",
    showOnForm: true,
  }),
  createField({
    backendKey: "OtherFees",
    label: "Others",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Professional Fees",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "UtilityFees",
    label: "Utilities",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Professional Fees",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "NewBuildWarranty",
    label: "New Build Warranty",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Professional Fees",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "CommunityInfrastructureLevyFees",
    label: "S106/CIL",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Professional Fees",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "BankIMS",
    label: "Bank IMS",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Professional Fees",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "MarketingFees",
    label: "Marketing",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Marketing",
    showOnForm: true,
    visibleWhen: isDevelopmentLoan,
  }),
  createField({
    backendKey: "Legal1PurchaseCost",
    label: "Legal 1 Cost",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Purchase Costs",
    showOnForm: true,
  }),
  createField({
    backendKey: "Legal2PurchaseCost",
    label: "Legal 2 Cost",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Purchase Costs",
    showOnForm: true,
  }),
  createField({
    backendKey: "OverheadCost",
    label: "Overhead Cost",
    type: "float",
    requiredFlag: "Y",
    section: "Cost Details",
    subSection: "Site Overheads",
    showOnForm: true,
  }),
  createField({
    backendKey: "RiskStatus",
    label: "Risk Status",
    type: "optionset",
    requiredFlag: "N",
    defaultValue:"Low",
    section: "Risk Rating",
    showOnForm: true,
  }),
];

export const LOAN_STEPS = MAIN_TABS.map((title) => ({
  title,
  fields: FIELD_CATALOG.filter(
    (field) => field.showOnForm && field.section === title
  ),
})).filter((step) => step.fields.length > 0);

export const ALL_FIELDS = FIELD_CATALOG;

export const PERCENTAGE_FIELD_KEYS = [
  "SVR",
  "FixedRate",
  "MarginRate",
  "ArrangementFeeRate",
  "ExitFeeRate",
  "BrokerFeeRate",
  "ValuationFeeRate",
  "LenderFeeRate",
  "ContingencyPercent",
  "StampDutyPercent",
];

export const LEGACY_KEY_MAP = {
  LoanName: "loanName",
  BorrowerName: "borrowerName",
  KeyPrincipalName: "keyPrincipalName",
  ExposureGroupName: "exposuregroupname",
  PropertyAddress: "propertyAddress",
  City: "city",
  Postcode: "postcode",
  Region: "region",
  ProductType: "productType",
  LoanType: "loanType",
  LoanPurpose: "loanPurpose",
  DevelopmentType: "developmentType",
  UnitType: "unitType",
  LoanSource: "loanSource",
  LeadSourceDetail: "leadSourceDetail",
  AccountReferenceNumber: "accountReferenceNumber",
  MigrationIndicator: "migrationIndicator",
  SecurityTenureType: "securityTenureType",
  CustomerType: "customerType",
  Currency: "currency",
  BusinessDevelopmentManager: "businessDevelopmentManager",
  LendingDirector: "lendingDirector",
  RelationshipManager: "relationshipManager",
  PortfolioManager: "portfolioManager",
  DrawdownDistributionType: "drawdownDistributionType",
  AOTLimit: "aotLimit",
  // BuildTrancheLimit: "buildTrancheLimit",
  // LandDrawdown: "landDrawdown",
  LoanTerm: "loanTerm",
  ProjectStartDate: "projectStartDate",
  BuildStartDate: "buildStartDate",
  PracticalCompletionDate: "practicalCompletionDate",
  SVR: "svr",
  RateType: "rateType",
  FixedRate: "fixedRate",
  MarginRate: "marginRate",
  DayCountBasis: "dayCountBasis",
  InterestPaymentMethod: "interestPaymentMethod",
  ArrangementFeeRate: "arrangementFeeRate",
  ArrangementFeeAmount: "arrangementFeeAmount",
  ArrangementFeePaymentMethod: "arrangementFeePaymentMethod",
  // CommitmentFeeRate: "commitmentFeeRate",
  CommitmentFeeAmount: "commitmentFeeAmount",
  ExitFeeRate: "exitFeeRate",
  ExitFeeAmount: "exitFeeAmount",
  ExitStrategy: "exitStrategy",
  // MonitoringFeeRate: "monitoringFeeRate",
  // MonitoringFeeAmount: "monitoringFeeAmount",
  // MonitoringFeePaymentMethod: "monitoringFeePaymentMethod",
  BrokerFeeRate: "brokerFeeRate",
  BrokerFeeAmount: "brokerFeeAmount",
  BrokerFeePaymentMethod: "brokerFeePaymentMethod",
  ValuationFeeRate: "valuationFeeRate",
  ValuationFeeAmount: "valuationFeeAmount",
  ValuationFeePaymentMethod: "valuationFeePaymentMethod",
  LenderFeeRate: "lenderFeeRate",
  LenderFeeAmount: "lenderFeeAmount",
  LenderFeePaymentMethod: "lenderFeePaymentMethod",
  PolicyType: "policyType",
  Insurer: "insurer",
  PolicyNumber: "policyNumber",
  InsuranceStartDate: "insuranceStartDate",
  InsuranceEndDate: "insuranceEndDate",
  SumInsured: "sumInsured",
  Excess: "excess",
  LenderNoted: "lenderNoted",
  RepaymentProfile: "repaymentProfile",
  BrokerNotes: "brokerNotes",
  PriorityStatus: "priorityStatus",
  CreatedBy: "createdBy",
  PurchasePrice: "purchasePrice",
  AmountSpentSincePurchase: "amountSpentSincePurchase",
  StampDutyPercent: "stampDutyPercent",
  DemoAndInfrastructure: "demoAndInfrastructure",
  EquitySpentByBorrowerOnConstruction: "equitySpentByBorrowerOnConstruction",
  MainBuild: "mainBuild",
  // EquitySpentByBorrowerOnUnitConstruction:
  //   "equitySpentByBorrowerOnUnitConstruction",
  ContingencyPercent: "contingencyPercent",
  ProfessionalFees: "professionalFees",
  OtherFees: "otherFees",
  UtilityFees: "utilityFees",
  NewBuildWarranty: "newBuildWarranty",
  CommunityInfrastructureLevyFees: "communityInfrastructureLevyFees",
  BankIMS: "bankIMS",
  MarketingFees: "marketingFees",
  RiskStatus: "riskStatus",
};

export const FEE_MODE_OPTIONS = [
  { label: "Rate", value: "rate" },
  { label: "Amount", value: "amount" },
];

export const FEE_MODE_DEFAULTS = {
  arrangementFee: "rate",
  exitFee: "rate",
  commitmentFee: "amount",
  monitoringFee: "rate",
  brokerFee: "rate",
  valuationFee: "amount",
  lenderFee: "amount",
  servicedHybrid: "rate",
};

export const FEE_GROUPS = [
  { key: "lenderFee", title: "Lender Legal Fee" },
  { key: "commitmentFee", title: "Commitment Fee" },
  { key: "arrangementFee", title: "Arrangement Fee" },
  { key: "exitFee", title: "Exit Fee" },
  { key: "monitoringFee", title: "Monitoring Fee" },
  { key: "brokerFee", title: "Broker Fee" },
  { key: "valuationFee", title: "Valuation Fee" },
];
